import { Form, Formik } from 'formik';
import React from 'react';

import { createDeliveryLineFromProject } from '~/@user-store/deliveryLines/deliveryLine.requests';
import { DeliveryLineDumpLoad } from '~/@views/UserView/ProjectPage/common/DeliveryLineEditForm/DeliveryLineFormikCommon';
import { IProject } from '~/@views/UserView/ProjectPage/ProjectMassesDetails/types';
import { useUserAbilities } from '~/contexts';
import { canCreateDeliveryLineFromProject } from '~/utils/auth';

import { getDeliveryLineCreateFormikConfig } from './DeliveryLineCreateFormik';
import { DeliveryLineEditActions } from './DeliveryLineEditActions';
import { DeliveryLineEditFields } from './DeliveryLineEditFields';
import { DeliveryLineEditLayout } from './DeliveryLineEditLayout';
import { DeliveryLineReceiptView } from './DeliveryLineReceiptView';

type Props = {
    project: IProject;
    onClose: (v: boolean) => void;
};

export const DeliveryLineCreateForm = ({ project, onClose }: Props) => {
    const abilityContext = useUserAbilities();
    const canCreate = (dumpLoad: DeliveryLineDumpLoad) =>
        canCreateDeliveryLineFromProject(abilityContext, dumpLoad, project);

    return (
        <Formik
            {...getDeliveryLineCreateFormikConfig(
                input => createDeliveryLineFromProject(project.id, input),
                project,
                null,
                canCreate
            )}>
            {({ values }) => (
                <DeliveryLineEditLayout
                    form={
                        <Form>
                            <DeliveryLineEditFields />
                            <DeliveryLineEditActions onClose={onClose} />
                        </Form>
                    }
                    preview={<DeliveryLineReceiptView newReceipt={values.receipt} />}
                />
            )}
        </Formik>
    );
};
